/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthRoutesRouteRouteImport } from './routes/_unauthRoutes/route'
import { Route as AuthRoutesRouteRouteImport } from './routes/_authRoutes/route'
import { Route as UnauthRoutesLoginRouteImport } from './routes/_unauthRoutes/login'
import { Route as AuthRoutesSplatRouteImport } from './routes/_authRoutes/$'
import { Route as AuthRoutesAppWrapperRouteRouteImport } from './routes/_authRoutes/_appWrapper/route'
import { Route as AuthRoutesAppWrapperIndexRouteImport } from './routes/_authRoutes/_appWrapper/index'
import { Route as AuthRoutesAppWrapperTeacherGuidelinesRouteImport } from './routes/_authRoutes/_appWrapper/teacher-guidelines'
import { Route as AuthRoutesAppWrapperLessonPlanningRouteImport } from './routes/_authRoutes/_appWrapper/lesson-planning'
import { Route as AuthRoutesLessonLessonIdPresentationRouteImport } from './routes/_authRoutes/lesson.$lessonId.presentation'
import { Route as AuthRoutesLessonLessonIdAudienceRouteImport } from './routes/_authRoutes/lesson.$lessonId.audience'
import { Route as AuthRoutesAppWrapperLessonLessonIdRouteImport } from './routes/_authRoutes/_appWrapper/lesson/$lessonId'
import { Route as AuthRoutesAppWrapperLessonSplatRouteImport } from './routes/_authRoutes/_appWrapper/lesson/$'

const UnauthRoutesRouteRoute = UnauthRoutesRouteRouteImport.update({
  id: '/_unauthRoutes',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoutesRouteRoute = AuthRoutesRouteRouteImport.update({
  id: '/_authRoutes',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthRoutesLoginRoute = UnauthRoutesLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthRoutesRouteRoute,
} as any)
const AuthRoutesSplatRoute = AuthRoutesSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthRoutesRouteRoute,
} as any)
const AuthRoutesAppWrapperRouteRoute =
  AuthRoutesAppWrapperRouteRouteImport.update({
    id: '/_appWrapper',
    getParentRoute: () => AuthRoutesRouteRoute,
  } as any)
const AuthRoutesAppWrapperIndexRoute =
  AuthRoutesAppWrapperIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthRoutesAppWrapperRouteRoute,
  } as any)
const AuthRoutesAppWrapperTeacherGuidelinesRoute =
  AuthRoutesAppWrapperTeacherGuidelinesRouteImport.update({
    id: '/teacher-guidelines',
    path: '/teacher-guidelines',
    getParentRoute: () => AuthRoutesAppWrapperRouteRoute,
  } as any)
const AuthRoutesAppWrapperLessonPlanningRoute =
  AuthRoutesAppWrapperLessonPlanningRouteImport.update({
    id: '/lesson-planning',
    path: '/lesson-planning',
    getParentRoute: () => AuthRoutesAppWrapperRouteRoute,
  } as any)
const AuthRoutesLessonLessonIdPresentationRoute =
  AuthRoutesLessonLessonIdPresentationRouteImport.update({
    id: '/lesson/$lessonId/presentation',
    path: '/lesson/$lessonId/presentation',
    getParentRoute: () => AuthRoutesRouteRoute,
  } as any)
const AuthRoutesLessonLessonIdAudienceRoute =
  AuthRoutesLessonLessonIdAudienceRouteImport.update({
    id: '/lesson/$lessonId/audience',
    path: '/lesson/$lessonId/audience',
    getParentRoute: () => AuthRoutesRouteRoute,
  } as any)
const AuthRoutesAppWrapperLessonLessonIdRoute =
  AuthRoutesAppWrapperLessonLessonIdRouteImport.update({
    id: '/lesson/$lessonId',
    path: '/lesson/$lessonId',
    getParentRoute: () => AuthRoutesAppWrapperRouteRoute,
  } as any)
const AuthRoutesAppWrapperLessonSplatRoute =
  AuthRoutesAppWrapperLessonSplatRouteImport.update({
    id: '/lesson/$',
    path: '/lesson/$',
    getParentRoute: () => AuthRoutesAppWrapperRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof AuthRoutesSplatRoute
  '/login': typeof UnauthRoutesLoginRoute
  '/lesson-planning': typeof AuthRoutesAppWrapperLessonPlanningRoute
  '/teacher-guidelines': typeof AuthRoutesAppWrapperTeacherGuidelinesRoute
  '/': typeof AuthRoutesAppWrapperIndexRoute
  '/lesson/$': typeof AuthRoutesAppWrapperLessonSplatRoute
  '/lesson/$lessonId': typeof AuthRoutesAppWrapperLessonLessonIdRoute
  '/lesson/$lessonId/audience': typeof AuthRoutesLessonLessonIdAudienceRoute
  '/lesson/$lessonId/presentation': typeof AuthRoutesLessonLessonIdPresentationRoute
}
export interface FileRoutesByTo {
  '/$': typeof AuthRoutesSplatRoute
  '/login': typeof UnauthRoutesLoginRoute
  '/lesson-planning': typeof AuthRoutesAppWrapperLessonPlanningRoute
  '/teacher-guidelines': typeof AuthRoutesAppWrapperTeacherGuidelinesRoute
  '/': typeof AuthRoutesAppWrapperIndexRoute
  '/lesson/$': typeof AuthRoutesAppWrapperLessonSplatRoute
  '/lesson/$lessonId': typeof AuthRoutesAppWrapperLessonLessonIdRoute
  '/lesson/$lessonId/audience': typeof AuthRoutesLessonLessonIdAudienceRoute
  '/lesson/$lessonId/presentation': typeof AuthRoutesLessonLessonIdPresentationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authRoutes': typeof AuthRoutesRouteRouteWithChildren
  '/_unauthRoutes': typeof UnauthRoutesRouteRouteWithChildren
  '/_authRoutes/_appWrapper': typeof AuthRoutesAppWrapperRouteRouteWithChildren
  '/_authRoutes/$': typeof AuthRoutesSplatRoute
  '/_unauthRoutes/login': typeof UnauthRoutesLoginRoute
  '/_authRoutes/_appWrapper/lesson-planning': typeof AuthRoutesAppWrapperLessonPlanningRoute
  '/_authRoutes/_appWrapper/teacher-guidelines': typeof AuthRoutesAppWrapperTeacherGuidelinesRoute
  '/_authRoutes/_appWrapper/': typeof AuthRoutesAppWrapperIndexRoute
  '/_authRoutes/_appWrapper/lesson/$': typeof AuthRoutesAppWrapperLessonSplatRoute
  '/_authRoutes/_appWrapper/lesson/$lessonId': typeof AuthRoutesAppWrapperLessonLessonIdRoute
  '/_authRoutes/lesson/$lessonId/audience': typeof AuthRoutesLessonLessonIdAudienceRoute
  '/_authRoutes/lesson/$lessonId/presentation': typeof AuthRoutesLessonLessonIdPresentationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/login'
    | '/lesson-planning'
    | '/teacher-guidelines'
    | '/'
    | '/lesson/$'
    | '/lesson/$lessonId'
    | '/lesson/$lessonId/audience'
    | '/lesson/$lessonId/presentation'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/login'
    | '/lesson-planning'
    | '/teacher-guidelines'
    | '/'
    | '/lesson/$'
    | '/lesson/$lessonId'
    | '/lesson/$lessonId/audience'
    | '/lesson/$lessonId/presentation'
  id:
    | '__root__'
    | '/_authRoutes'
    | '/_unauthRoutes'
    | '/_authRoutes/_appWrapper'
    | '/_authRoutes/$'
    | '/_unauthRoutes/login'
    | '/_authRoutes/_appWrapper/lesson-planning'
    | '/_authRoutes/_appWrapper/teacher-guidelines'
    | '/_authRoutes/_appWrapper/'
    | '/_authRoutes/_appWrapper/lesson/$'
    | '/_authRoutes/_appWrapper/lesson/$lessonId'
    | '/_authRoutes/lesson/$lessonId/audience'
    | '/_authRoutes/lesson/$lessonId/presentation'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoutesRouteRoute: typeof AuthRoutesRouteRouteWithChildren
  UnauthRoutesRouteRoute: typeof UnauthRoutesRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthRoutes': {
      id: '/_unauthRoutes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthRoutesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authRoutes': {
      id: '/_authRoutes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRoutesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthRoutes/login': {
      id: '/_unauthRoutes/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthRoutesLoginRouteImport
      parentRoute: typeof UnauthRoutesRouteRoute
    }
    '/_authRoutes/$': {
      id: '/_authRoutes/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthRoutesSplatRouteImport
      parentRoute: typeof AuthRoutesRouteRoute
    }
    '/_authRoutes/_appWrapper': {
      id: '/_authRoutes/_appWrapper'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRoutesAppWrapperRouteRouteImport
      parentRoute: typeof AuthRoutesRouteRoute
    }
    '/_authRoutes/_appWrapper/': {
      id: '/_authRoutes/_appWrapper/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthRoutesAppWrapperIndexRouteImport
      parentRoute: typeof AuthRoutesAppWrapperRouteRoute
    }
    '/_authRoutes/_appWrapper/teacher-guidelines': {
      id: '/_authRoutes/_appWrapper/teacher-guidelines'
      path: '/teacher-guidelines'
      fullPath: '/teacher-guidelines'
      preLoaderRoute: typeof AuthRoutesAppWrapperTeacherGuidelinesRouteImport
      parentRoute: typeof AuthRoutesAppWrapperRouteRoute
    }
    '/_authRoutes/_appWrapper/lesson-planning': {
      id: '/_authRoutes/_appWrapper/lesson-planning'
      path: '/lesson-planning'
      fullPath: '/lesson-planning'
      preLoaderRoute: typeof AuthRoutesAppWrapperLessonPlanningRouteImport
      parentRoute: typeof AuthRoutesAppWrapperRouteRoute
    }
    '/_authRoutes/lesson/$lessonId/presentation': {
      id: '/_authRoutes/lesson/$lessonId/presentation'
      path: '/lesson/$lessonId/presentation'
      fullPath: '/lesson/$lessonId/presentation'
      preLoaderRoute: typeof AuthRoutesLessonLessonIdPresentationRouteImport
      parentRoute: typeof AuthRoutesRouteRoute
    }
    '/_authRoutes/lesson/$lessonId/audience': {
      id: '/_authRoutes/lesson/$lessonId/audience'
      path: '/lesson/$lessonId/audience'
      fullPath: '/lesson/$lessonId/audience'
      preLoaderRoute: typeof AuthRoutesLessonLessonIdAudienceRouteImport
      parentRoute: typeof AuthRoutesRouteRoute
    }
    '/_authRoutes/_appWrapper/lesson/$lessonId': {
      id: '/_authRoutes/_appWrapper/lesson/$lessonId'
      path: '/lesson/$lessonId'
      fullPath: '/lesson/$lessonId'
      preLoaderRoute: typeof AuthRoutesAppWrapperLessonLessonIdRouteImport
      parentRoute: typeof AuthRoutesAppWrapperRouteRoute
    }
    '/_authRoutes/_appWrapper/lesson/$': {
      id: '/_authRoutes/_appWrapper/lesson/$'
      path: '/lesson/$'
      fullPath: '/lesson/$'
      preLoaderRoute: typeof AuthRoutesAppWrapperLessonSplatRouteImport
      parentRoute: typeof AuthRoutesAppWrapperRouteRoute
    }
  }
}

interface AuthRoutesAppWrapperRouteRouteChildren {
  AuthRoutesAppWrapperLessonPlanningRoute: typeof AuthRoutesAppWrapperLessonPlanningRoute
  AuthRoutesAppWrapperTeacherGuidelinesRoute: typeof AuthRoutesAppWrapperTeacherGuidelinesRoute
  AuthRoutesAppWrapperIndexRoute: typeof AuthRoutesAppWrapperIndexRoute
  AuthRoutesAppWrapperLessonSplatRoute: typeof AuthRoutesAppWrapperLessonSplatRoute
  AuthRoutesAppWrapperLessonLessonIdRoute: typeof AuthRoutesAppWrapperLessonLessonIdRoute
}

const AuthRoutesAppWrapperRouteRouteChildren: AuthRoutesAppWrapperRouteRouteChildren =
  {
    AuthRoutesAppWrapperLessonPlanningRoute:
      AuthRoutesAppWrapperLessonPlanningRoute,
    AuthRoutesAppWrapperTeacherGuidelinesRoute:
      AuthRoutesAppWrapperTeacherGuidelinesRoute,
    AuthRoutesAppWrapperIndexRoute: AuthRoutesAppWrapperIndexRoute,
    AuthRoutesAppWrapperLessonSplatRoute: AuthRoutesAppWrapperLessonSplatRoute,
    AuthRoutesAppWrapperLessonLessonIdRoute:
      AuthRoutesAppWrapperLessonLessonIdRoute,
  }

const AuthRoutesAppWrapperRouteRouteWithChildren =
  AuthRoutesAppWrapperRouteRoute._addFileChildren(
    AuthRoutesAppWrapperRouteRouteChildren,
  )

interface AuthRoutesRouteRouteChildren {
  AuthRoutesAppWrapperRouteRoute: typeof AuthRoutesAppWrapperRouteRouteWithChildren
  AuthRoutesSplatRoute: typeof AuthRoutesSplatRoute
  AuthRoutesLessonLessonIdAudienceRoute: typeof AuthRoutesLessonLessonIdAudienceRoute
  AuthRoutesLessonLessonIdPresentationRoute: typeof AuthRoutesLessonLessonIdPresentationRoute
}

const AuthRoutesRouteRouteChildren: AuthRoutesRouteRouteChildren = {
  AuthRoutesAppWrapperRouteRoute: AuthRoutesAppWrapperRouteRouteWithChildren,
  AuthRoutesSplatRoute: AuthRoutesSplatRoute,
  AuthRoutesLessonLessonIdAudienceRoute: AuthRoutesLessonLessonIdAudienceRoute,
  AuthRoutesLessonLessonIdPresentationRoute:
    AuthRoutesLessonLessonIdPresentationRoute,
}

const AuthRoutesRouteRouteWithChildren = AuthRoutesRouteRoute._addFileChildren(
  AuthRoutesRouteRouteChildren,
)

interface UnauthRoutesRouteRouteChildren {
  UnauthRoutesLoginRoute: typeof UnauthRoutesLoginRoute
}

const UnauthRoutesRouteRouteChildren: UnauthRoutesRouteRouteChildren = {
  UnauthRoutesLoginRoute: UnauthRoutesLoginRoute,
}

const UnauthRoutesRouteRouteWithChildren =
  UnauthRoutesRouteRoute._addFileChildren(UnauthRoutesRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoutesRouteRoute: AuthRoutesRouteRouteWithChildren,
  UnauthRoutesRouteRoute: UnauthRoutesRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
